var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBgShapeYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 689,
    height: 374,
    viewBox: "0 0 689 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1678_6945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -5,
    width: 689,
    height: 379
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.737244 -4.68457H688.521V374H0.737244V-4.68457Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1678_6945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5656 -21.7098C-7.55643 50.4123 -7.55643 167.356 64.5656 239.492C111.646 286.573 182.15 304.764 246.154 286.456C284.095 275.597 307.708 251.955 337.88 228.05C429.316 155.593 554.844 86.5025 673.362 134.545C708.184 148.669 672.866 79.8412 667.415 69.6089C559.319 -133.347 292.17 -196.549 106.428 -57.9458C91.6187 -46.8972 77.6257 -34.7699 64.5656 -21.6952V-21.7098Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.547 -15.9674C7.70453 52.8751 7.70453 164.484 76.547 233.326C121.485 278.264 188.768 295.624 249.856 278.147C286.063 267.784 308.612 245.22 337.399 222.409C424.666 153.245 544.48 87.3036 657.605 133.16C690.853 146.628 657.138 80.9485 651.935 71.168C548.751 -122.533 293.773 -182.833 116.5 -50.5562C102.361 -40.0032 89.0096 -28.4298 76.5325 -15.9674H76.547Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5141 -10.2238C22.9512 55.3391 22.9512 161.627 88.5141 227.176C131.295 269.956 195.385 286.5 253.558 269.854C288.045 259.986 309.501 238.501 336.918 216.768C420.016 150.914 534.117 88.1205 641.848 131.776C673.507 144.603 641.396 82.0569 636.441 72.7428C538.198 -111.702 295.391 -169.131 126.572 -43.1656C113.118 -33.1227 100.394 -22.1033 88.5141 -10.2238Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.496 -4.4807C38.2269 57.788 38.2269 158.756 100.496 221.025C141.133 261.663 202.003 277.375 257.26 261.561C290.013 252.188 310.405 231.782 336.452 211.142C415.381 148.582 523.768 88.9369 626.092 130.42C656.162 142.606 625.669 83.194 620.961 74.3463C527.631 -100.872 296.995 -155.43 136.644 -35.7754C123.861 -26.2427 111.777 -15.7625 100.496 -4.4807Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.477 1.26171C53.4881 60.2508 53.4881 155.884 112.477 214.873C150.972 253.368 208.635 268.25 260.978 253.281C292.01 244.404 311.323 225.076 335.986 205.515C410.761 146.264 513.419 89.7526 610.35 129.05C638.831 140.594 609.942 84.3158 605.481 75.9346C517.078 -90.0424 298.598 -141.714 146.716 -28.3713C134.604 -19.3342 123.161 -9.40792 112.477 1.27629V1.26171Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.444 7.00525C68.7492 62.7002 68.7492 153.013 124.444 208.708C160.797 245.061 215.253 259.112 264.665 244.973C293.963 236.592 312.198 218.328 335.505 199.875C406.111 143.918 503.056 90.5695 594.578 127.665C621.471 138.568 594.2 85.4242 589.987 77.5094C506.525 -79.2118 300.216 -128.012 156.788 -20.9807C145.346 -12.4537 134.545 -3.08134 124.459 7.00525H124.444Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.425 12.7482C84.0099 65.1635 84.0099 150.142 136.425 202.557C170.635 236.767 221.87 249.987 268.382 236.679C295.945 228.794 313.116 211.609 335.038 194.234C401.475 141.571 492.707 91.3712 578.836 126.281C604.14 136.542 578.472 86.532 574.507 79.0836C495.957 -68.3818 301.819 -114.296 166.845 -13.5906C156.088 -5.55924 145.914 3.25924 136.425 12.7482Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.407 18.4912C99.2713 67.6269 99.2713 147.27 148.407 196.406C180.474 228.473 228.502 240.863 272.084 228.386C297.928 220.996 314.02 204.889 334.557 188.608C396.826 139.253 482.343 92.1875 563.065 124.911C586.795 134.531 562.73 87.6543 559.013 80.6724C485.404 -57.5518 303.437 -100.595 176.918 -6.18596C166.831 1.33525 157.298 9.59985 148.392 18.5058L148.407 18.4912Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.373 24.2338C114.532 70.0753 114.532 144.398 160.373 190.254C190.298 220.179 235.105 231.738 275.786 220.106C299.895 213.197 314.908 198.184 334.09 182.981C392.205 136.921 471.994 93.0179 547.323 123.555C569.464 132.533 547.017 88.7909 543.547 82.2754C474.836 -46.7222 305.04 -86.8791 187.004 1.20367C177.588 8.2293 168.696 15.94 160.388 24.2483L160.373 24.2338Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.355 29.9763C129.793 72.5383 129.793 141.541 172.355 184.088C200.137 211.87 241.737 222.598 279.503 211.797C301.892 205.384 315.827 191.449 333.624 177.34C387.57 134.588 461.645 93.8192 531.581 122.17C552.133 130.492 531.289 89.8983 528.068 83.8492C464.283 -35.8926 306.644 -73.1781 197.062 8.59332C188.33 15.1088 180.066 22.2656 172.355 29.9763Z",
    stroke: "#DD9326",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgShapeYellow);
export default __webpack_public_path__ + "static/media/hero_bg_shape_yellow.06d7682fd5afba8332019843ebf907eb.svg";
export { ForwardRef as ReactComponent };